/* eslint-disable import/no-duplicates */
import HalfStar from '@atom-web/icons-24/HalfStar'
import Google from '@atom-web/icons-24/jsx/Google'
import HalfChecked from '@atom-web/icons-24/jsx/HalfChecked'
import Location from '@atom-web/icons-24/jsx/Location'
import Star from '@atom-web/icons-24/jsx/Star'
import RadioButtonChecked from '@atom-web/icons-24/RadioButtonChecked'
import TripAdvisor from '@atom-web/icons-24/TripAdvisor'
import { Box, Column, Flex, Row, Stack, Text } from '@atom-web/micros'
import Image from 'next/image'
import { useMemo } from 'react'

import ContentWrapper from '../../../../components/ContentWrapper'
import customImageLoader from '../../../../utils/customImageLoader'
import getImgIXUrl from '../../../../utils/getImgIXUrl'

export default ({
	images,
	resortName,
	starRating,
	atoll,
	gaRating,
	googleReviewCount,
	tripAdvisorRating,
}) => {
	const isSTRFloat = useMemo(
		() => (starRating % 1 !== 0 ? true : false),
		[starRating],
	)
	const isTARFloat = useMemo(
		() => (starRating % 1 !== 0 ? true : false),
		[starRating],
	)

	return (
		<Flex
			css={{
				position: 'relative',
				width: '100%',
				height: '75vh',
				alignItems: 'flex-end',

				'@lg': {
					height: '576px',
				},

				'&::after': {
					width: '100%',
					height: '25%',
					position: 'absolute',
					bottom: 0,
					left: 0,
					content: '',
					background: 'linear-gradient(180deg,transparent,rgba(0,0,0,.8))',
				},
			}}
		>
			{images?.[0] ? (
				<Image
					src={
						getImgIXUrl(images?.[0], 'w=1440&h=600&fit=crop', 100, 2, false) ||
						''
					}
					loader={customImageLoader}
					layout="fill"
					priority
					objectFit="cover"
				/>
			) : null}
			<Box
				css={{
					position: 'absolute',
					bottom: 0,
					left: 0,
					zIndex: 1,
					width: '100%',
				}}
			>
				<ContentWrapper>
					<Row
						css={{
							width: '100%',
							flex: 1,
							justifyContent: 'space-between',
						}}
					>
						<Column
							gap="2"
							css={{
								flexWrap: 'wrap',
								paddingBottom: '10px',
							}}
						>
							<Text
								as="h1"
								css={{
									fontSize: '24px',
									color: '$white',
									letterSpacing: '-0.46px',
									lineHeight: 1.23,
									fontWeight: '$bold',
									'@lg': {
										fontSize: '30px',
									},
								}}
							>
								{resortName}
							</Text>
							<Row>
								{starRating &&
									new Array(Math.floor(starRating))
										.fill(null)
										.map((_, key) => (
											<Star fill="#ffc933" key={'star-rating' + key} />
										))}
								{isSTRFloat && (
									<HalfStar fill="#ffc933" key={'half-star-rating'} />
								)}
								<Row
									gap="1"
									css={{
										marginLeft: '$2',
									}}
								>
									<Location fill="#AAAAAA" />
									<Text
										as="span"
										css={{
											fontSize: '15px',
											letterSpacing: '-0.3px',
											lineHeight: '$1',
											color: '#AAAAAA',
										}}
									>
										{atoll}
									</Text>
								</Row>
							</Row>
						</Column>

						<Row
							css={{
								width: '368px',
								borderTopLeftRadius: 4,
								borderTopRightRadius: 4,
								backgroundColor: 'rgba(0,0,0,0.8)',
								paddingLeft: '$3',
								paddingTop: '$4',
								paddingBottom: '$4',
								justifyContent: 'center',
								'@smMax': {
									display: 'none',
								},
							}}
						>
							<Stack
								gap="8"
								seperator={
									<Box
										css={{
											border: '1px solid $colors$grey09',
										}}
									/>
								}
							>
								<Row
									css={{
										alignItems: 'center',
									}}
									gap="2"
								>
									<Google fill="#fff" width="26px" height="26px" />
									<Column>
										<Text
											css={{
												fontSize: '18px',
												fontWeight: '$bold',
												lineHeight: '23.94px',
												letterSpacing: '-0.29px',
												color: '#ffc933',
											}}
										>
											{gaRating} / 5
										</Text>
										<Text
											css={{
												fontSize: '11px',
												lineHeight: '12.98px',
												letterSpacing: '-0.15px',
												color: 'hsla(0,0%,100%,.9)',
											}}
										>
											{googleReviewCount} reviews
										</Text>
									</Column>
								</Row>
								<Row
									css={{
										alignItems: 'center',
									}}
									gap="2"
								>
									<TripAdvisor fill="#fff" width="34px" height="34px" />
									<Column gap="1">
										{tripAdvisorRating ? (
											<Row>
												{new Array(Math.floor(tripAdvisorRating))
													.fill(null)
													.map((_, key) => (
														<RadioButtonChecked
															fill="hsla(0,0%,100%,.9)"
															key={'trip-advisor-star-rating' + key}
															width="12px"
															height="12px"
														/>
													))}
												{isTARFloat && (
													<HalfChecked
														fill="hsla(0,0%,100%,.9)"
														key={'trip-advisor-half-star-rating'}
														width="12px"
														height="12px"
													/>
												)}
											</Row>
										) : null}
										<Text
											css={{
												fontSize: '11px',
												lineHeight: '12.98px',
												letterSpacing: '-0.15px',
												color: 'hsla(0,0%,100%,.9)',
											}}
										>
											on Tripadvisor
										</Text>
									</Column>
								</Row>
							</Stack>
						</Row>
					</Row>
				</ContentWrapper>
			</Box>
		</Flex>
	)
}
